import { autoinject, bindable } from 'aurelia-framework';
import { CreateAnalysisCompanyDto } from 'models/AnalysisCompany';

@autoinject
export class AnalysisCompanyFormBasic {
  @bindable
  private analysisCompany: CreateAnalysisCompanyDto;

  constructor() {}
}
